import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

import { CurrentUserService } from 'services/currentUser';
import { IAugmentedJQuery } from 'angular';
import { selectedWindMitigationDiscount } from 'common/source/utilities/policyInfoHelper';

interface CertificationNameMap {
    [key: string]: string;
}

const CERTIFICATION_NAME: CertificationNameMap = {
    international_residence_code: '2006 International Residence Code',
    safer_living: 'FORTIFIED for Safer Living IBHS program',
    gold: 'FORTIFIED Home Gold IBHS program',
    silver: 'FORTIFIED Home Silver IBHS program',
    bronze: 'FORTIFIED Home Bronze IBHS program'
};

const module = angular.module('windstorm-retrofitting-certification-section', []);

interface WindstormRetrofittingCertificationSectionController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;

    sectionTitle: string;
    sectionDescription: string;
}

module.component('windstormRetrofittingCertificationSection', {
    bindings: {
        policyInfo: '<'
    },
    template: template,
    controller: function(this: WindstormRetrofittingCertificationSectionController) {
        this.$onInit = () => {
            this.sectionTitle = 'Windstorm retrofitting certification';

            const windMitigation = this.policyInfo.property_data.wind_mitigation;

            let windMitigationCertificationFormName;

            if (windMitigation === 'international_residence_code') {
                windMitigationCertificationFormName = 'Verification Affidavit (PL-14868)';
            } else {
                windMitigationCertificationFormName = 'FFSLS certified inspection';
            }

            if (this.policyInfo && !!windMitigation && selectedWindMitigationDiscount(this.policyInfo)) {
                this.sectionDescription = `You indicated that your house is certified to meet the
                <strong>${CERTIFICATION_NAME[windMitigation]}</strong>.
                In order to approve this discount, we
                need you to send us a copy of <strong>${windMitigationCertificationFormName}</strong> to
                <strong>support@myhippo.com</strong>. For assistance or questions of any kind, we're here to
                help! Just give us a call at <strong>1-800-585-0705</strong>.`;
            }
        };
    }
});

export { module };
